import { Grid, Typography, MenuItem } from '@material-ui/core';
import { useFormState, useForm } from 'react-final-form';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { v4 as uuid } from 'uuid';
import _ from 'lodash';

import QCXFormStepWizard from '../../../../../shared-components/form-step-wizard/QCXFormStepWizard';
import QCXFinalAlternativeCurrencyField from '../../../../../shared-components/final-currency-field/QCXFinalAlternativeCurrencyField';
import QCXSelectMoedaAutocomplete from '../../../../../shared-components/final-select-moeda-field/QCXSelectMoedaAutocomplete';
import QCXTextField from '../../../../../shared-components/text-field/QCXTextField';
import QCXSelectDespesaReceitaAutocomplete from '../../../../../shared-components/select-despesa-receita/QCXSelectDespesaReceitaAutocomplete';
import QCXFinalBondManager from '../../../../../shared-components/final-gerenciador-relacionamento/QCXFinalBondManager';
import SelectManyCustosAdicionais from './SelectManyCustosAdicionais';

export default function TarifarioCustosAdicionaisDataForm({
  initialValues,
  handleSubmit,
  isConsult,
  isUpdate,
  controlComponentProps,
  authInfo = {},
  requiredRoles = [],
  handleChange,
}){

  const { t } = useTranslation();
  

  return (
    <QCXFormStepWizard
      initialValues={initialValues}
      onSubmit={handleSubmit}
      controlComponentProps={controlComponentProps}
      authInfo={authInfo}
      requiredRoles={requiredRoles}
    >
      {({ form, values, submitSucceeded }) => (
        <>
          <SelectManyCustosAdicionais
            isConsult={isConsult}
            handleChange={handleChange}
          />
        </>
      )}    
    </QCXFormStepWizard>
  )
}
